import { render, staticRenderFns } from "./FormatSection.vue?vue&type=template&id=91401cb2&"
import script from "./FormatSection.vue?vue&type=script&lang=js&"
export * from "./FormatSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports